<template>
  <div class="est-room__filelist">
    <p v-if="!multimediaList.length" class="est-room__empty">{{ $t('OnlineMeetingComponent.FilesEmpty') }}</p>

    <div v-else class="est-room__files">
      <a v-for="media in multimediaList"
         :key="media.id"
         :href="media.url"
         class="est-room__file"
         :title="media.fileName"
         target="_blank"
         rel="noopener">
        <img v-if="isImage(media)" class="est-room__file-thumb" :src="media.thumbnailUrl || media.url" :alt="media.fileName">
        <span v-else class="est-room__file-icon" aria-hidden="true">
          <font-awesome-icon icon="fa-solid fa-file" />
          <span class="est-room__file-ext">{{ extensionLabel(media) }}</span>
        </span>
        <span class="est-room__file-name">{{ media.fileName }}</span>
      </a>
    </div>
  </div>
</template>

<script>
  import MeetingService from '../../../services/meeting.js'

  const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];

  // Görüşme sırasında paylaşılan dosyalar. Görsel olmayan dosya için dış bir
  // yer tutucu servis (via.placeholder.com) çağrılıyordu; danışan sayfasından
  // üçüncü tarafa istek çıkmasın diye ikon karo basılır.
  export default {
    name: 'MeetingMultimediaComponent',
    props: {
      meeting: {
        type: Object,
        default: null
      }
    },
    data: function () {
      return {
        multimediaList: []
      }
    },
    methods: {
      isImage(media) {
        return IMAGE_EXTENSIONS.includes(String(media.fileExtension || '').toLowerCase());
      },
      extensionLabel(media) {
        return String(media.fileExtension || '').replace('.', '').toUpperCase();
      },
      getMultimedia() {
        if (!this.meeting || !this.meeting.id) return;

        MeetingService.getMultimedia(this.meeting.id)
          .then(list => {
            this.multimediaList = Array.isArray(list) ? list : [];
          })
          .catch(error => console.error(error));
      }
    },
    created: function () {
      this.$bus.$on('RefreshMultimediaList', this.getMultimedia);
    },
    mounted: function () {
      this.getMultimedia();
    },
    beforeDestroy: function () {
      this.$bus.$off('RefreshMultimediaList', this.getMultimedia);
    }
  }
</script>
